import { Link } from "react-router-dom";
import { Check, ArrowRight } from "lucide-react";
import StockImage from "@/components/StockImage";

const SERVICES = [
  {
    nr: "01",
    tag: "Mietkoch · B2B",
    title: "Gastronomiebetriebe",
    text: "Verstärkung in der Küche bei Personalausfall, Saisonspitzen oder zusätzlichem Bedarf. À-la-carte-Service, Mittag- und Abendservice.",
    points: ["Posten Garde-Manger", "Posten Saucier / Entremetier", "Service-Unterstützung am Pass"],
    image: "https://images.unsplash.com/photo-1574936145840-28808d77a0b6?w=1600&q=80&auto=format&fit=crop",
  },
  {
    nr: "02",
    tag: "Mietkoch · B2B",
    title: "Hotels",
    text: "Frühstücksdienst, Halbpension, Restaurantbetrieb und Bankettküche. Eingespielter Ablauf für planbare Spitzenzeiten.",
    points: ["Frühstücks- & Bankettküche", "Bankett bis 200 Personen", "Vertretung bei Krankheit / Urlaub"],
    image: "https://images.unsplash.com/photo-1455587734955-081b22074882?w=1600&q=80&auto=format&fit=crop",
  },
  {
    nr: "03",
    tag: "Mietkoch · B2B",
    title: "Restaurants",
    text: "Klassische, moderne oder regionale Küche — flexible Anpassung an Ihr Konzept und Ihre Standards.",
    points: ["Mise en Place", "Eigene à-la-carte-Posten", "Saubere Übergabe"],
    image: "/images/04.jpg",
  },
  {
    nr: "04",
    tag: "Mietkoch · B2B",
    title: "Firmenevents & Bankette",
    text: "Unterstützung bei Geschäftsessen, Firmenfeiern und Banketten in bestehenden Gastronomiebetrieben — als Verstärkung des Küchenteams am Veranstaltungsort.",
    points: ["Einsatz im Gastro-Betrieb", "B2B-Unterstützung", "Bedarfsabsprache vorab"],
    gallery: ["/images/60.jpg", "/images/61.jpg"],
  },
  {
    nr: "05",
    tag: "Privatkoch · für Privatkunden",
    title: "Privatkoch & Private Dining",
    text: "Ihr Menü-Abend in Ihrer eigenen Küche — vom Geburtstag über den Hochzeitstag bis zum Weihnachtsessen. Ich übernehme Einkauf, Vorbereitung, Kochen am Abend und den Service am Tisch. Zum Abschied bleibt eine aufgeräumte Küche zurück.",
    points: [
      "Menü-Vorschläge ganz nach Ihrem Geschmack — Fine Dining, regional, vegetarisch oder vegan",
      "Ab 2 Gästen, auch in Ferienwohnung oder Eventlocation — größere Runden auf Anfrage",
      "Allergien & Unverträglichkeiten werden vorab abgestimmt",
      "Fester Preis pro Person inkl. Ware — keine Überraschungen auf der Rechnung",
    ],
    image: "https://images.unsplash.com/photo-1731481382640-4859340396a7?w=1600&q=80&auto=format&fit=crop",
    cta: { to: "/privatkoch", label: "Private Dining entdecken" },
  },
  {
    nr: "06",
    tag: "Vermittlung · für Betriebe",
    title: "Koch-Vermittlung",
    text: "Wenn ich selbst keinen Termin frei habe, bleiben Sie nicht ohne Koch: Ich vermittle geprüfte selbstständige Mietköche aus meinem Netzwerk — für einzelne Einsatztage, ganze Saisons oder direkt in Festanstellung.",
    points: [
      "Jeder Koch ist von mir persönlich geprüft: Gewerbeanmeldung, Lebenslauf, § 43 IfSG-Belehrung",
      "Passend nach Umkreis, Küchenbereich und Position ausgewählt",
      "40 € netto Provision je Koch und Einsatztag — Sie zahlen nur bei tatsächlichem Einsatz",
      "Festanstellung: 100 € netto einmalig · Provisionsvereinbarung digital unterschreiben",
    ],
    image: "https://images.unsplash.com/photo-1577219491135-ce391730fb2c?w=1600&q=80&auto=format&fit=crop",
    cta: { to: "/vermittlung", label: "Koch anfordern" },
  },
];

export default function Leistungen() {
  return (
    <div data-testid="page-leistungen">
      <section className="border-b border-[#E3DECE]">
        <div className="max-w-7xl mx-auto px-6 md:px-12 py-20 md:py-28">
          <p className="text-xs uppercase tracking-[0.25em] font-semibold text-[#BA6D52]">Leistungen</p>
          <div className="mt-8 grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-20 items-start">
            <h1 className="lg:col-span-6 font-serif text-4xl sm:text-5xl lg:text-6xl font-light tracking-tighter leading-[1.08]">
              Handwerk auf Abruf —<br className="hidden sm:block" /> wenn es darauf ankommt.
            </h1>
            <div className="lg:col-span-6 lg:pt-3">
              <p className="text-[#757067] font-light text-base md:text-lg leading-[1.85]">
                Drei Bereiche, ein Anspruch: Als <b className="text-[#2C2A26] font-medium">Mietkoch</b>{" "}
                unterstütze ich Ihren Betrieb dort, wo kurzfristig Verstärkung fehlt. Als{" "}
                <b className="text-[#2C2A26] font-medium">Privatkoch</b> koche ich Ihren Menü-Abend bei
                Ihnen zuhause. Und über meine{" "}
                <b className="text-[#2C2A26] font-medium">Koch-Vermittlung</b> finden Betriebe geprüfte
                selbstständige Köche aus meinem Netzwerk.
              </p>
              <div className="mt-10 flex flex-wrap gap-3" data-testid="leistungen-bereiche-nav">
                {[["Mietkoch für Betriebe", "/anfrage-betrieb"],
                  ["Privatkoch für Zuhause", "/privatkoch"],
                  ["Koch-Vermittlung", "/vermittlung"]].map(([l, to]) => (
                  <Link key={to} to={to}
                    className="border border-[#E3DECE] bg-white text-[#2C2A26] hover:border-[#BA6D52] hover:text-[#BA6D52] px-5 py-3 text-[11px] uppercase tracking-[0.18em] transition-colors">
                    {l}
                  </Link>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      <section>
        <div className="max-w-7xl mx-auto px-6 md:px-12 py-20 md:py-28 space-y-24">
          {SERVICES.map((s, idx) => (
            <div
              key={s.nr}
              className={`grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 items-center ${
                idx % 2 === 1 ? "lg:[&>div:first-child]:order-2" : ""
              }`}
            >
              <div className="lg:col-span-6">
                {s.gallery ? (
                  <div className="grid grid-cols-2 gap-3" data-testid={`leistung-collage-${s.nr}`}>
                    {s.gallery.map((g, gi) => (
                      <StockImage
                        key={gi}
                        aspect="aspect-[3/4]"
                        src={g}
                        alt={`${s.title} ${gi + 1}`}
                      />
                    ))}
                  </div>
                ) : (
                  <StockImage aspect="aspect-[4/3]" src={s.image} alt={s.title} />
                )}
              </div>
              <div className="lg:col-span-6">
                {s.tag && (
                  <p className="text-[10px] uppercase tracking-[0.22em] text-[#BA6D52] mb-4">{s.tag}</p>
                )}
                <h2 className="font-serif text-4xl font-light tracking-tight text-[#2C2A26]">
                  {s.title}
                </h2>
                <p className="text-[#757067] font-light leading-relaxed mt-4 text-lg">
                  {s.text}
                </p>
                <ul className="mt-8 space-y-3">
                  {s.points.map((p) => (
                    <li key={p} className="flex items-start gap-3 text-[#2C2A26]">
                      <Check size={18} className="text-[#BA6D52] mt-1 shrink-0" />
                      <span className="font-light">{p}</span>
                    </li>
                  ))}
                </ul>
                {s.cta && (
                  <Link to={s.cta.to} data-testid={`leistung-cta-${s.nr}`}
                    className="mt-8 inline-flex items-center gap-3 bg-[#BA6D52] text-white hover:bg-[#9E5841] px-7 py-4 text-[11px] uppercase tracking-[0.2em] transition-colors">
                    {s.cta.label} <ArrowRight size={15} />
                  </Link>
                )}
              </div>
            </div>
          ))}
        </div>
      </section>

      <section className="border-t border-[#E3DECE] bg-[#F2EFE9]">
        <div className="max-w-7xl mx-auto px-6 md:px-12 py-20 md:py-28 text-center">
          <p className="text-xs uppercase tracking-[0.25em] text-[#BA6D52]">Nächster Schritt</p>
          <h2 className="font-serif text-4xl sm:text-5xl font-light tracking-tighter mt-6 max-w-2xl mx-auto">
            Unverbindlich anfragen — ich melde mich persönlich.
          </h2>
          <div className="mt-10 flex flex-wrap justify-center gap-3">
            <Link
              to="/anfrage"
              data-testid="leistungen-cta-anfrage"
              className="inline-flex items-center gap-3 bg-[#BA6D52] text-white hover:bg-[#9E5841] px-8 py-5 text-xs uppercase tracking-[0.2em] transition-colors"
            >
              Anfrage stellen <ArrowRight size={16} />
            </Link>
            <Link
              to="/vermittlung"
              data-testid="leistungen-cta-vermittlung"
              className="inline-flex items-center gap-3 border border-[#BA6D52] text-[#BA6D52] hover:bg-white px-8 py-5 text-xs uppercase tracking-[0.2em] transition-colors"
            >
              Koch-Vermittlung
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}
